/**
 * Function that returns an array of objects with additional properties taken from another object
 * @param {Array} arr
 * @param {Object} obj
 * @param {String} key
 * @param {String} value
 */

const arrPropertyExtender = (arr, obj, key, value) => {
  return arr.map((el) => {
    let o = Object.assign({}, el);
    o[key] = obj[el[value]];
    return o;
  });
};

export default {
  arrPropertyExtender,
};
